var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("main", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "vstack gap-4" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-7 mb-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header bg-white px-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-between align-items-center",
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-6 d-flex justify-content-end" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("v-select", {
                                staticClass: "form-control form-control-sm",
                                staticStyle: { width: "85px" },
                                attrs: {
                                  items: _vm.years,
                                  "hide-details": "",
                                  dense: "",
                                },
                                on: { change: _vm.USERS },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-select__selection v-select__selection--comma",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                        " +
                                                _vm._s(item) +
                                                "\n                                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.form.year,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "year", $$v)
                                  },
                                  expression: "form.year",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "justify-content-center align-items-center",
                        class: _vm.loading ? "d-none" : "d-flex",
                        staticStyle: { height: "275px" },
                      },
                      [_vm._m(2)]
                    ),
                    _vm._v(" "),
                    _c("line-chart", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { height: "275px" },
                      attrs: { chartData: _vm.chartDataUsers },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-5 mb-3" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card-body",
                    staticStyle: { height: "315px" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "list-group gap-4" },
                      _vm._l(_vm.data.lasts, function (item, key) {
                        return _c(
                          "div",
                          {
                            key: key,
                            staticClass:
                              "list-group-item d-flex align-items-center border rounded",
                          },
                          [
                            _vm._m(4, true),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-fill" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "d-block h6 font-semibold mb-1 text-decoration-none text-dark",
                                  attrs: { href: "#" },
                                },
                                [_vm._v(_vm._s(item.type) + _vm._s(item.id))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "d-block text-sm text-muted" },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-4 mb-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "h6 font-semibold text-muted text-sm d-block mb-2",
                        },
                        [_vm._v("Total Usuarios Registrados")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "h3 font-bold mb-0" }, [
                        _vm._v(_vm._s(_vm.data.total)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(5),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-4 mb-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "h6 font-semibold text-muted text-sm d-block mb-2",
                        },
                        [_vm._v("Total Usuarios Activos")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "h3 font-bold mb-0" }, [
                        _vm._v(_vm._s(_vm.data.enabled)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(6),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-4 mb-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "h6 font-semibold text-muted text-sm d-block mb-2",
                        },
                        [_vm._v("Total Usuarios Registrados del Mes")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "h3 font-bold mb-0" }, [
                        _vm._v(_vm._s(_vm.data.months)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(7),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-12 mb-3" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header bg-white px-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-content-between align-items-center",
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-6 d-flex justify-content-end" },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("v-select", {
                                staticClass: "form-control form-control-sm",
                                staticStyle: { width: "85px" },
                                attrs: {
                                  items: _vm.years,
                                  "hide-details": "",
                                  dense: "",
                                },
                                on: { change: _vm.PACKAGES },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-select__selection v-select__selection--comma",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                        " +
                                                _vm._s(item) +
                                                "\n                                                    "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.form.year_package,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "year_package", $$v)
                                  },
                                  expression: "form.year_package",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "justify-content-center align-items-center",
                        class: _vm.loading_packages ? "d-none" : "d-flex",
                        staticStyle: { height: "275px" },
                      },
                      [_vm._m(9)]
                    ),
                    _vm._v(" "),
                    _c("line-chart", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading_packages,
                          expression: "loading_packages",
                        },
                      ],
                      staticStyle: { height: "275px" },
                      attrs: { chartData: _vm.chartDataPackages },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Tablero")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6" }, [
      _c("h2", { staticClass: "subtitle mb-0" }, [_vm._v("Usuarios")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-grow text-dark", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "card-header border-bottom-0 bg-white d-flex align-items-center",
        staticStyle: { height: "56px" },
      },
      [
        _c("h2", { staticClass: "subtitle mb-0" }, [
          _vm._v("Ultimos Usuarios Registrados"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "me-4" }, [
      _c(
        "div",
        {
          staticClass:
            "icon icon-shape bg-dark text-white text-lg rounded-circle",
        },
        [_c("i", { staticClass: "fa-solid fa-user" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c(
        "div",
        {
          staticClass:
            "icon icon-shape bg-primary text-white text-lg rounded-circle",
        },
        [_c("i", { staticClass: "fa-solid fa-users" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c(
        "div",
        {
          staticClass:
            "icon icon-shape bg-success text-white text-lg rounded-circle",
        },
        [_c("i", { staticClass: "fa-solid fa-user-tag" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c(
        "div",
        {
          staticClass:
            "icon icon-shape bg-orange text-white text-lg rounded-circle",
        },
        [_c("i", { staticClass: "fa-solid fa-user-clock" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6" }, [
      _c("h2", { staticClass: "subtitle mb-0" }, [
        _vm._v("Paquetes entregados"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-grow text-dark", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }